import browser from '../../../helpers/browser';

export default (colorClass) => {
  if (browser.isRetina() && colorClass) return `${colorClass}_retina`;

  return '';
};
